import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/services/modal/modal.service';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { Cabinet, EtatDeploiementEnum } from 'src/app/utils/interfaces/new/cabinet.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';

@Component({
  selector: 'app-office-management',
  templateUrl: './office-management.component.html',
  styleUrls: ['./office-management.component.scss']
})
export class OfficeManagementComponent implements OnInit {

  public officeColumnTable = [];
  public officeList: Paginated<Cabinet>;
  public search = '';
  public searchOffice = 'office';
  public filtre: Filtres = {
    perpage: 99999,
    currentPage: 1
  };

  constructor(
    private officeService: CabinetService,
    private router: Router,
    private _viewRef: ViewContainerRef,
    private modalService: ModalService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.officeColumnTable = [
      { title: 'Nom du cabinet', data: 'nom' },
      { title: 'Adresse du cabinet', data: 'adresse' },
      { title: 'Type', data: 'type' },
      { title: 'Déploiement', data: 'etatDeploiementView' },
      { title: 'Profils', data: 'qtyProfilsStr' },
      { title: 'Cert. DMP', data: 'certificatDmpExists' },
      { title: 'Cert. INSI', data: 'certificatInsiExists' },
      { title: 'Effacer', data: null },
      { title: 'Modifier', data: null }
    ];

    await this.getCabinet();
  }

  public async deleteOffice(cabinet: Cabinet): Promise<void> {
    const modal = this.modalService.openModalConfirmation(this._viewRef, 'Confirmation', 'Voulez-vous vraiment supprimer ce cabinet ?');
    modal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        const loadingModal = this.modalService.openLoading(this._viewRef);
        try {
          await this.officeService.delete(cabinet);
          await this.getCabinet();
          this.modalService.close(loadingModal);
        } catch (e) {
          this.modalService.close(loadingModal);
          console.error(e);
        }
      }
    });
  }

  public editOffice(office: any): void {
    this.router.navigateByUrl(`/administration/office-creation/${office.id}`);
  }

  private adminPage(): void {
    this.router.navigate(['administration/']);
  }

  public async onSort(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.sortOrder = event.sortOrder;
    this.filtre.sortBy = event.sortBy;

    if (this.filtre?.sortBy === 'qtyProfilsStr') {
      this.filtre.sortBy = 'qtyProfils';
    } else if (this.filtre?.sortBy === 'etatDeploiementView') {
      this.filtre.sortBy = 'etatDeploiement';
    }

    this.getCabinet();
  }

  public async onSearch(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.find = event;
    this.getCabinet();
  }

  public async onChangePage(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.getCabinet();
  }

  public async getCabinet(): Promise<void> {
    this.officeList = await this.officeService.find(this.filtre);
    for (const cabinet of this.officeList.objects) {
      cabinet.adresse = cabinet.adresse + ', ' + cabinet.codePostal + ' ' + cabinet.ville;
      switch (cabinet.type) {
        case "msp":
          cabinet.type = "Maison de santé pluridisciplinaire";
          break;
        case "cs":
          cabinet.type = "Centre de santé";
          break;
        default:
          break;
      }
      switch (cabinet.etatDeploiement) {
        case EtatDeploiementEnum.Deploye:
          (cabinet as any).etatDeploiementView = "🟢 Déployé"
          break;
        case EtatDeploiementEnum.EnCours:
          (cabinet as any).etatDeploiementView = "🟠 En cours"
          break;
        case EtatDeploiementEnum.Erreur:
          (cabinet as any).etatDeploiementView = "⚠️ En erreur"
          break;
        case EtatDeploiementEnum.NonDeploye:
          (cabinet as any).etatDeploiementView = "🔴 Non déployé"
          break;
      }

      if (cabinet.certificatDmpExists) {
        (cabinet as any).certificatDmpExists = "🟢 Oui"
      } else {
        (cabinet as any).certificatDmpExists = "🔴 Non"
      }

      if (cabinet.certificatInsiExists) {
        (cabinet as any).certificatInsiExists = "🟢 Oui"
      } else {
        (cabinet as any).certificatInsiExists = "🔴 Non"
      }

      if (cabinet.qtyProfils > 0) {
        (cabinet as any).qtyProfilsStr = `${cabinet.qtyProfils}`;

        if (cabinet.qtyProfilsActifs > 0) {
          (cabinet as any).qtyProfilsStr += ` (${cabinet.qtyProfilsActifs})`;
        }
      }
    }
  }

}
